import { useState } from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Tab,
  Tabs,
  Tooltip,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { TabPanel } from '../../../components/tab-panel';
import { fileColumns } from './grid-columns';
import { SiTrackGrid } from '../../../components/si-track-grid/si-track-grid';
import { fileUploadApiKeyStore } from '../../../api/file-upload-key-store';
import { UploadFileComponent } from './upload-file.component';
import { useFileDownload } from '../../../components/file-download';
import { UserPermissionName } from '../../../models/user-permission-name';

const styling = {
  dialogTitleStyle: { padding: '16px 24px 0' },
  contentPadding: { paddingTop: '30px' },
  buttonPadding: { paddingTop: '20px' },
  tabHeading: { fontWeight: 'bold' },
  buttonStyle: { width: '130px' },
};

interface DocumentRequestArgs {
  projectID?: number;
  tempEntityID?: any;
}

interface ProjectDocumentDialog {
  open: boolean;
  onClose: () => void;
  documentRequestArgs: DocumentRequestArgs;
}
export const ProjectDocumentDialog = ({ open, onClose, documentRequestArgs }: ProjectDocumentDialog) => {
  const [value, setValue] = useState('create');
  const [fileUploadReqArgs, setFileUploadReqArgs] = useState(documentRequestArgs);
  const [newFiles, saveNewFiles] = useState<any[]>([]);
  const [editItem, setEditItem] = useState<any>();
  const { downloadFile, isLoading } = useFileDownload();

  const handleFileUploadCompleted = (value: any) => {
    setFileUploadReqArgs({ ...fileUploadReqArgs, tempEntityID: value.tempEntityID });
    // saveNewFiles([...newFiles, value]);
    setValue('view');
  };

  const handleEdit = (value: any) => {
    setEditItem(value);
    setValue('edit');
  };

  const handleClosed = () => {
    onClose();
  };

  const handleDownloadFile = async (data: any) => {
    downloadFile({ additionalData: data });
  };

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth={'xl'}
      // onClose={handleClosed}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" sx={{ p: 0, m: 0 }}>
        <Tabs value={value} onChange={(event: any, value: string) => setValue(value)}>
          <Tab value="view" label={<div style={styling.tabHeading}>FILE LIST</div>} />
          <Tab value="create" label={<div style={styling.tabHeading}>UPLOAD FILES</div>} hidden={!!editItem} />
          <Tab value="edit" label={<div style={styling.tabHeading}>EDIT UPLOAD FILE</div>} hidden={!editItem} />
        </Tabs>
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClosed}
        sx={{
          position: 'absolute',
          right: 10,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Tooltip title={<Typography variant="body1">Close</Typography>}>
          <CloseIcon />
        </Tooltip>
      </IconButton>
      <DialogContent dividers className="popupDilog">
        <TabPanel selectedValue={value} value="view">
          <Grid container spacing={2}>
            <Grid item lg={12} sm={12} xl={12} xs={12}>
              <SiTrackGrid
                fileTitle='project_file'
                dataItems={newFiles}
                dataItemKey="fileID"
                columns={fileColumns}
                queryConfig={fileUploadApiKeyStore.getFiles(documentRequestArgs)}
                onDownload={(data: any) => {
                  handleDownloadFile(data);
                }}
                actionPermissions={{
                  edit: UserPermissionName.EDIT_FILE,
                  delete: UserPermissionName.DELETE_FILE,
                  download: UserPermissionName.DOWNLOAD_FILE,
                  export: UserPermissionName.DOWNLOAD_GRID,
                }}
                onEdit={handleEdit}
                deleteMutationConfig={(item) => fileUploadApiKeyStore.deleteFile(item.fileID)}
                isBusy={isLoading}
              />
            </Grid>
            <Grid item lg={12} sm={12} xl={12} xs={12}>
              <Grid container justifyContent="flex-end">
                <Button variant="outlined" style={{ width: '130px' }} onClick={handleClosed}>
                  Cancel
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </TabPanel>
        <TabPanel selectedValue={value} value="create">
          <UploadFileComponent
            documentRequestArgs={fileUploadReqArgs}
            onSaveComplete={handleFileUploadCompleted}
            onClose={handleClosed}
          />
        </TabPanel>
        <TabPanel selectedValue={value} value="edit">
          <UploadFileComponent
            fileData={editItem}
            documentRequestArgs={fileUploadReqArgs}
            onSaveComplete={handleFileUploadCompleted}
            onClose={handleClosed}
          />
        </TabPanel>
      </DialogContent>
    </Dialog>
  );
};
